import { render, staticRenderFns } from "./aRmsStrategyColumnLabels.vue?vue&type=template&id=18cc9de2"
import script from "./aRmsStrategyColumnLabels.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyColumnLabels.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyColumnLabels.vue?vue&type=style&index=0&id=18cc9de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports